export default __webpack_public_path__ + "static/media/recipe.412546da.svg";